import { Directive, inject, input } from '@angular/core'
import { SidebarService } from './sidebar.service'

@Directive({
    selector: '[sfSidebarToggle]',
    exportAs: 'sfSidebarToggle',
    host: {
        '(click)': 'toggleOpen($event)',
    },
})
export class SidebarToggleDirective {
    readonly #sidebarService = inject(SidebarService)

    /**
     * Id of sidebar for toggle action.
     * @return string
     */
    readonly id = input<string>(undefined, { alias: 'sfSidebarToggle' })
    /**
     * Sidebar property name for toggle action.
     *
     * @return 'visible' | 'unfoldable'
     * @default 'visible'
     */
    readonly toggle = input<'visible' | 'unfoldable'>('visible')

    toggleOpen($event: any): void {
        $event.preventDefault()
        this.#sidebarService.toggle({ toggle: this.toggle(), id: this.id() })
    }
}
